// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"ActiveStudentList_filterContainer__2r-j7","paginationWrapper":"ActiveStudentList_paginationWrapper__3IrF-","loading":"ActiveStudentList_loading__1CXFL"};